import { c as _c } from "react/compiler-runtime";
import type { ActivityLogParams } from "@/components/profile-activity/ProfileActivityLogs";
import type { ApiCicOverview } from "@/generated/models/ApiCicOverview";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import { RateMatter } from "@/types/enums";
import { FingerprintIcon } from "../identity/header/RateNicCta";
import UserPageIdentityStatementsAddButton from "../identity/statements/add/UserPageIdentityStatementsAddButton";
import UserPageIdentityStatements from "../identity/statements/UserPageIdentityStatements";
import UserPageRateWrapper from "../utils/rate/UserPageRateWrapper";
import UserPageCombinedActivityLog from "./UserPageCombinedActivityLog";
export default function MobileIdentityTabContent(t0) {
  const $ = _c(20);
  const {
    profile,
    cicOverview,
    initialActivityLogParams,
    canEditNic,
    canEditStatements,
    onRateNic
  } = t0;
  let t1;
  if ($[0] !== canEditNic || $[1] !== cicOverview || $[2] !== onRateNic || $[3] !== profile) {
    t1 = canEditNic && <div className="tw-mt-4"><UserPageRateWrapper profile={profile} type={RateMatter.NIC} hideOwnProfileMessage={true}><button type="button" onClick={onRateNic} className="tw-flex tw-w-full tw-cursor-pointer tw-items-center tw-justify-between tw-rounded-xl tw-border tw-border-solid tw-border-emerald-500/20 tw-bg-emerald-500/5 tw-px-4 tw-py-2.5 tw-transition tw-duration-300 tw-ease-out hover:tw-bg-emerald-500/10">{cicOverview !== null && cicOverview.authenticated_user_contribution !== null && cicOverview.authenticated_user_contribution !== 0 ? <span className="tw-flex tw-items-center tw-gap-2 tw-text-xs tw-font-medium tw-text-iron-500"><FingerprintIcon className="tw-h-4 tw-w-4 tw-flex-shrink-0 tw-text-emerald-400" />Your Rating:{" "}<span className="tw-font-semibold tw-text-iron-300">{cicOverview.authenticated_user_contribution > 0 && "+"}{formatNumberWithCommas(cicOverview.authenticated_user_contribution)}</span></span> : <span className="tw-text-xs tw-font-medium tw-text-emerald-200/70">Verify this identity</span>}<span className="tw-flex tw-flex-shrink-0 tw-items-center tw-gap-1.5 tw-rounded-lg tw-border tw-border-solid tw-border-emerald-600 tw-bg-emerald-600 tw-px-3 tw-py-1.5 tw-text-xs tw-font-semibold tw-text-white">Rate NIC</span></button></UserPageRateWrapper></div>;
    $[0] = canEditNic;
    $[1] = cicOverview;
    $[2] = onRateNic;
    $[3] = profile;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <h3 className="tw-mb-0 tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wider tw-text-iron-100">ID Statements</h3>;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== canEditStatements || $[7] !== profile) {
    t3 = canEditStatements && <UserPageIdentityStatementsAddButton profile={profile} />;
    $[6] = canEditStatements;
    $[7] = profile;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t3) {
    t4 = <div className="tw-mt-6 tw-flex tw-items-center tw-justify-between">{t2}{t3}</div>;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== profile) {
    t5 = <div className="tw-mt-3 tw-rounded-xl tw-border tw-border-solid tw-border-white/[0.08] tw-bg-[#0f1014]"><UserPageIdentityStatements profile={profile} /></div>;
    $[11] = profile;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== initialActivityLogParams) {
    t6 = <div className="tw-mt-6"><UserPageCombinedActivityLog initialActivityLogParams={initialActivityLogParams} matter={RateMatter.NIC} withMatterFilter={false} /></div>;
    $[13] = initialActivityLogParams;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t1 || $[16] !== t4 || $[17] !== t5 || $[18] !== t6) {
    t7 = <>{t1}{t4}{t5}{t6}</>;
    $[15] = t1;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
}